import { css } from 'styled-components';

export const missionBackground = css`
  --tile-size: 44px;
  --offset: calc(var(--tile-size) / 2);
  position: relative;
  isolation: isolate;
  background: radial-gradient(
      ellipse at top left,
      var(--ellipse-color, transparent),
      transparent 60%
    ),
    linear-gradient(to bottom, transparent, var(--c-black) 100%),
    linear-gradient(
      to bottom,
      rgba(var(--rgb-color), var(--opacity, 0.2)),
      var(--c-nl-100) 40%
    );

  &:before {
    content: '';
    z-index: -1;
    position: absolute;
    inset: 0;
    display: block;
    opacity: 0.3;
    background: repeating-linear-gradient(
        to bottom,
        var(--c-white) var(--offset),
        transparent calc(var(--offset) + 1px),
        transparent calc(var(--offset) + var(--tile-size))
      ),
      repeating-linear-gradient(
        to right,
        var(--c-white) var(--offset),
        transparent calc(var(--offset) + 1px),
        transparent calc(var(--offset) + var(--tile-size))
      );
    mix-blend-mode: overlay;
  }
`;
